import { ToastT } from 'sonner';
import { ToastIcon } from './toastIcon';

type Props = {
  classes: any;
  type: ToastT['type'];
  title: string;
  description?: string;
};

export const CustomToast = ({ type = 'error', title, description }: Props) => {
  return (
    <div className="flex gap-1.5">
      <div className="mr-1 -ml-px flex shrink-0 items-center justify-center">
        <ToastIcon type={type} />
      </div>
      <div className="flex flex-col">
        <div className="leading-[1.5] font-medium">{title}</div>
        <div className="leading-[1.4]">{description}</div>
      </div>
    </div>
  );
};
